var jaJp = {
  locale: 'ja_JP',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'YYYY/WW',
      date: 'YYYY/MM/DD',
      month: 'YYYY/MM',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'YYYY/MM/DD HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['1 月', '2 月', '3 月', '4 月', '5 月', '6 月', '7 月', '8 月', '9 月', '10 月', '11 月', '12 月'],
    monthList: ['1 月', '2 月', '3 月', '4 月', '5 月', '6 月', '7 月', '8 月', '9 月', '10 月', '11 月', '12 月'],
    shortDayList: ['日', '月', '火', '水', '木', '金', '土'],
    dayList: ['日', '月', '火', '水', '木', '金', '土'],
    shortestDayList: ['日', '月', '火', '水', '木', '金', '土']
  },
  'dynamic-date': {
    day: '日',
    week: '週',
    month: '月',
    quarter: '四半期',
    year: '年',
    before: '${value}${unit} より前'
  },
  'auto-complete.empty': 'データがありません',
  'select.selected-count': '${count} 個のアイテムを選択しました',
  'date-time-picker.date': '日付を選択してください',
  'image-view.zoom-out': 'ズームアウト',
  'input.placeholder': '入力してください',
  'empty.text': 'データがありません',
  'date-picker.cancel': 'キャンセル',
  'date-picker.end': '終了時間',
  'cascader.empty': 'データがありません',
  'upload.drop': 'ここにファイルをドラッグするか、',
  'color.custom': '色をカスタマイズ',
  'cascader.titles': ['レベル 1', 'レベル 2', 'レベル 3', 'レベル 4', 'レベル 5', 'レベル 6', 'レベル 7', 'レベル 8'],
  'date-comparison.error-target': '比較のため、終了時間を選択してください',
  'transfer.empty': 'データがありません',
  'select.search.placeholder': '入力してください',
  'upload.click': 'クリックしてアップロードしてください',
  'date-time-picker.placeholder': '入力してください',
  'pager.jump': 'リダイレクト',
  'tree-select.placeholder': '入力してください',
  'dynamic-date.interval': '間隔',
  'modal.cancel': 'キャンセル',
  'image-view.rotate': '回転',
  'tabs.more': 'その他',
  'popover.ok': '確認',
  'transfer.placeholder': '入力してください',
  'date.month': '月',
  'select.selected': '選択済み',
  'popover.cancel': 'キャンセル',
  'image-view.prev': '前へ',
  'table.emptyText': 'データがありません',
  'date-time-picker.ok': '確認',
  'table.filter.confirm': '確認',
  'tree-select.empty': 'データがありません',
  'dynamic-date.fixed-date': '固定された日付',
  'date-comparison.compare': '比較',
  'auto-complete.placeholder': '入力してください',
  'time-picker.placeholder': '時間を選択してください',
  'date.month-first': false,
  'select.clear': 'クリア',
  'date.year': '${year}年',
  'date-comparison.yoy': '昨年のこの期間',
  'image-view.zoom-to-origin': '元の画像',
  'schedule.title': '日付/時刻',
  'schedule.clear': 'クリア',
  'date-time-picker.end': '終了日時を選択してください',
  'dynamic-date.customize': 'カスタマイズ',
  'date-picker.apply': '適用',
  'schedule.selected': '選択した時間',
  'dynamic-date.dynamic-date': 'ダイナミックな日付設定',
  'select.placeholder': '選択してください',
  'schedule.separator': '、',
  'cascader.search': '入力してください',
  'date-picker.invalid-range': '選択した時間範囲が選択可能な範囲を超えています。有効な時間範囲を選択してください。',
  'dynamic-date.date-preview': '日付のプレビュー',
  'select.empty': 'データがありません',
  'image-view.next': '次へ',
  'date-time-picker.now': '今',
  'date-time-picker.time': '時間を選択してください',
  'tree.empty': 'データがありません',
  'pager.total': '合計 ${total} 件の記録',
  'image-view.zoom-in': 'ズームイン',
  'date-picker.placeholder': '日付を選択してください',
  'textarea.placeholder': '入力してください',
  'date.week': '週',
  'pager.size': '${count} 件の記録/ページ',
  'modal.ok': '確認',
  'date-picker.start': '開始時間',
  'table.filter.reset': 'リセット',
  'image-view.zoom-to-fit': 'サイズに合わせて縮小',
  'pager.page.placeholder': '入力してください',
  'select.select-all': 'すべてを選択',
  'list-viewer.empty': 'データがありません',
  'date-comparison.compare-text': 'VS',
  'transfer.source': 'ソースリスト',
  'date-time-picker.start': '開始日時を選択してください',
  'date-comparison.error-source': '比較のため、開始時刻を選択してください',
  'upload.error.overflow-count': 'ファイル数の上限を超えています',
  'date-comparison.placeholder': '開始時間 - 終了時間',
  'time-range-picker.placeholder': '開始時間 - 終了時間',
  'date-comparison.mom': '前回の期間と比較した場合',
  'transfer.target': 'ターゲットリスト'
};
export default jaJp;